<template>
	<div class="query-center">
		<h4>
			<span>消息记录</span>
			<a href="javascript:;" title="关闭消息记录" class="icon icon-cha pull-right" @click="$store.commit('changeShowMsgLog', false)"></a>
		</h4>
		<div :class="{list: true, 'msg-log-list': true, 'load-msg-log': $store.state.loadMsgLog}" v-html="$store.state.msgLog"></div>
		<form action="javascript:;" class="form">
			<el-date-picker
				v-model="time"
				type="daterange"
				range-separator="至"
				start-placeholder="开始日期"
				end-placeholder="结束日期">
			</el-date-picker>
			<input type="button" class="btn" value="搜索" @click="searchMsgLog">
		</form>
	</div>
</template>

<script>
export default {
	name: 'msgLogTpl',
	data () {
		return {
			time: ''
		}
	},
	computed: {
		currentConversation () {
			return this.$store.state.currentConversation;
		}
	},
	mounted () {
		document.getElementsByClassName("msg-log-list")[0].addEventListener('scroll', this.getMoreModalMsg);
	},
	methods: {
		// 搜索消息记录
		searchMsgLog () {
			var self = this,
				data = {
					sessionId: self.currentConversation.id,
					buyerNick: self.currentConversation.name,
					startDate: '',
					endDate: ''
				};

			if (self.time) {
				data.startDate = self.time[0].format('yyyy-MM-dd');
				data.endDate = self.time[1].format('yyyy-MM-dd');
			}

			self.$store.commit('changeMsgLog', self.$store.state.loading);
			self.$axios.post(API_ROOT.baseUrl + '/api/wwim/queryHistoryChatRecord', data).then(result => {
				if (result.code == 200) {
					self.$store.commit('changeMsgLog', result.data);
				} else {
					self.$store.commit('changeMsgLog', '<div class="shift">获取消息记录失败</div>');
				}
			}, response => {
				self.$store.commit('changeMsgLog', '<div class="shift">获取消息记录失败</div>');
			})
		},

		// 获取更多消息记录
		getMoreModalMsg () {
			var self = this;
				$list = document.getElementsByClassName("msg-log-list")[0],
				sT = $list.scrollTop,
				cH = $list.clientHeight,
				sH = $list.scrollHeight,
				data = {
					sessionId: self.currentConversation.id,
					buyerNick: self.currentConversation.name,
					startDate: '',
					endDate: ''
				};
				
			if ((cH + sT + 100 < sH) || self.$store.state.loadMsgLog || document.getElementById('J_HasNextPage').value == 'false') return;

			if (self.time) {
				data.startDate = self.time[0].format('yyyy-MM-dd');
				data.endDate = self.time[1].format('yyyy-MM-dd');
			}
			data.contentBeginKey = document.getElementById('J_EndKey').value;
			
			self.$store.commit('changeLoadMsgLog', true);

			self.$axios.post(API_ROOT.baseUrl + '/api/wwim/queryHistoryChatRecord', data).then(result => {
				if (result.code != 200) {
					self.$store.commit('changeLoadMsgLog', false);
					alert('获取消息记录失败');
				}
			}, response => {
				self.$store.commit('changeLoadMsgLog', false);
				alert('获取消息记录失败');
			})
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/aside/msgLogTpl.vue